export const mgPlatformArrowDownIcon = {
  data: `<svg viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.89 1.26001L8.39001 8.76001L0.890015 1.26001" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrow-down'
}
